import $ from 'utils/net';
import Config from "./config";
import PrematchFeed from "./prematch-feed";
import Page from "./page-data-feed";
import Ticket from "./ticket";
import { makeReactive } from '../utils/reactive-store';


export default class BetBuilder {
	_callEventoBuilderApi(categoryId, eventId, shortId) {
		return new Promise((res, rej) => {
			$.getJSON(Config.softionAPI + '/scommesse/eventobuilder/'+categoryId+'/'+eventId+'/'+shortId+'/?json&l='+Config.lang, (err, data) => {
				if (err) return rej(err);
				res(PrematchFeed.normalizeEventMarkets(data, '/event/'+eventId));
			});
		})
	}
	
	_callEventoBuilderCalculator(eventId, oddsIds) {
		return new Promise((res, rej) => {
			$.post(Config.softionAPI + '/schedina/oddsBuilder?json&l='+Config.lang, {
				json: true,
				body: {evento: eventId, selection: oddsIds},
			}, (err, data) => {
				if (err) return rej(err);
				res(data);
			});
		})
	}
	
	async getOddsForEvent(event) {
		const tournament = event.parent;
		const [sportId, categoryId, tournamentId] = tournament.split('/').slice(-3);
		const eventId = event.id.split('/').slice(-1)[0];
		const markets = await this._callEventoBuilderApi(categoryId, eventId, event.short);
		return markets;
	}
	
	async calculateSelectionsOdd(eventId, oddsIds) {
		if (oddsIds.length == 0) {
			return {
				disabled: {},
				oddValue: 1.00
			};
		}
		
		const response = await this._callEventoBuilderCalculator(
			eventId.replace('/event/', ''), 
			oddsIds.map(id => id.split('/').slice(-2).join('-'))
		);
		const oddBasePath = eventId.replace('event', 'odd') + '/';
		
		return {
			disabled: Object.fromEntries(response.disabled.map(code => [oddBasePath+code.replace('-', '/'), true])),
			oddValue: oddsIds.length == 1 ? 1 : parseFloat(response.betbuilder.esiti.quota),
			market: {
				id: eventId.replace('/event/', '/market/')+'/'+response.betbuilder.scommessa,
				name: response.betbuilder.desc,
				legatura: '1-30',
				sub: {
					[oddBasePath+response.betbuilder.scommessa+'/'+response.betbuilder.esiti.esito]: {
						id: oddBasePath+response.betbuilder.scommessa+'/'+response.betbuilder.esiti.esito,
						name: response.betbuilder.esiti.desc,
						value: oddsIds.length == 1 ? 1 : parseFloat(response.betbuilder.esiti.quota),
						selection: oddsIds
					}
				}
			}
		};
	}

	static getBetbuilderEventCalculator(event) {
		return new BetbuilderLogic(event);
	}
}

class BetbuilderLogic {
	betbuilder = new BetBuilder();
	
	_state = makeReactive({
		event: null,
		loading: true,
		selections: [],
		selectionsIds: {},
		oddValue: 0.00,
		apiResponse: {
			markets: [],
			disabled: {},
			market: null
		}
	});
	
	constructor(event) {
		this._state.event = event;
		
		this.betbuilder.getOddsForEvent(event).then(markets => {
			this._state.loading = false;
			this._state.apiResponse.markets = Object.values(markets).sort((a, b) => a.order - b.order);
			
			const preset = Ticket.getEventBetbuilder(this._state.event.id);
			if (!preset)
				return this.setState();
			
			for (var selection of preset.selection) {
				const marketId = '/market/'+selection.split('/').slice(-3, -1).join('/');
				if (!markets[marketId])
					continue;
				this.toggleOdd(markets[marketId].sub[selection], true);
			}
			
			this._calculate();
			
			this.setState();
		}).catch(e => {
			this._state.loading = false;
			this.setState();
		});
	}
	
	toggleOdd(outcome, returnEarly = false) {
		const marketId = outcome.id.replace('odd', 'market').split('/').slice(0, -1).join('/');
		const market = this._state.apiResponse.markets.find(market => market.id === marketId);
		if (!this._state.selectionsIds[outcome.id]) { // Aggiungi
			if (this.isOutcomeDisabled(outcome))
				return Promise.resolve(null);
			this._state.selections.push({
				id: outcome.id,
				market: market.name,
				outcome: outcome.name
			});
		} else { // Rimuovi
			this._state.selections = this._state.selections.filter(bbOutcome => bbOutcome.id != outcome.id);
		}
		this._state.selectionsIds = this._state.selections.reduce((c, outcome) => {c[outcome.id] = true; return c;}, {});
		this.setState();

		if (returnEarly)
			return Promise.resolve(null);
		
		// Le API vanno chiamate anche con una sola quota perché devi avere la lista delle quote da "spegnere"
		return this._calculate();
	}

	_calculate() {
		return this.betbuilder.calculateSelectionsOdd(this._state.event.id, this._state.selections.map(o => o.id)).then(response => {
			this._state.apiResponse.disabled = response.disabled;
			this._state.apiResponse.market = response.market;
			this._state.oddValue = response.oddValue;
			this.setState();
		});
	}

	addBetbuilderOdd() {
		if (this._state.oddValue <= 1.00)
			return;
		
		const customOdd = this._state.apiResponse.market;
		PrematchFeed.NStorage.storeData([customOdd]);

		// Se la quota già c'è la metto e la levo
		const oddId = Object.values(customOdd.sub)[0].id;
		if (Ticket.tmpHasPrematchOdd(oddId)) {
			Ticket.tmpTogglePrematchOdd(oddId);
		}
		Ticket.tmpTogglePrematchOdd(oddId);
		
		Page.rerender();
		this.onComplete();
	}

	reset() {
		this._state.selections = [];
		this._state.selectionsIds = {};
		this._state.oddValue = 0.00;
		this._state.apiResponse.disabled = {};

		this.setState();
		
		const customOdd = this._state.apiResponse.market;
		if (!customOdd) {
			return;
		}
		const oddId = Object.values(customOdd.sub)[0].id;
		if (Ticket.tmpHasPrematchOdd(oddId)) {
			Ticket.tmpTogglePrematchOdd(oddId);
		}
		
		Page.rerender();
	}

	isOutcomeDisabled(outcome) {
		if (!outcome.id)
			return true;
		const outcomeWithZero = outcome.id.split("/").slice(0, -1).join('/')+'/0';
		return !!this._state.apiResponse.disabled[outcome.id] || (!this.isOutcomeSelected(outcome) && !!this._state.apiResponse.disabled[outcomeWithZero]);
	}

	isOutcomeSelected(outcome) {
		return !!this._state.selectionsIds[outcome.id];
	}
	isLoading() {
		return this._state.loading
	}
	hasMarkets() {
		return this._state.apiResponse.markets.length > 0;
	}
	mapMarkets(cb) {
		return this._state.apiResponse.markets.map(cb);
	}
	mapSelections(cb) {
		return this._state.selections.map(cb);
	}
	countSelections() {
		return this._state.selections.length;
	}
	getOddValue() {
		return this._state.oddValue
	}
}

export {
	BetbuilderLogic
}